import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import * as fromControlActions from './control-type.actions';
import { ControlType } from './control-type.model';

export interface State {
    ids: Array<string>;
    entities: { [id: string]: ControlType };
}

export const initialState: State = {
    ids: [],
    entities: {}
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: fromControlActions.Actions): State {
    switch (action.type) {
        case fromControlActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromControlActions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case fromControlActions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/control-type/control-type.reducer.ts